import { render, staticRenderFns } from "./icare_modal.vue?vue&type=template&id=b62fbae0&"
import script from "./icare_modal.vue?vue&type=script&lang=js&"
export * from "./icare_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports